import React from 'react';
import * as S from './boleto-skeleton.molecule.style';

export const BoletoPageSkeleton: React.FC = () => {
  return (
    <S.Page>
      {/* Header */}
      <S.HeaderSkeleton />

      {/* Card central */}
      <S.Center>
        <S.Card>
          {/* Title */}
          <S.Title />
          <S.Subtitle />

          {/* Instructions */}
          <S.Section>
            <S.SectionTitle />
            <S.Paragraph />
            <S.Paragraph />
          </S.Section>

          {/* Order details */}
          <S.OrderDetails>
            <S.DetailRow>
              <S.DetailLabel />
              <S.DetailValue />
            </S.DetailRow>
            <S.DetailRow>
              <S.DetailLabel />
              <S.DetailValue />
            </S.DetailRow>
            <S.DetailRow>
              <S.DetailLabel />
              <S.DetailValue />
            </S.DetailRow>
          </S.OrderDetails>

          {/* Barcode */}
          <S.BarcodeSection>
            <S.BarcodeNumber />
            <S.BarcodeImage />
          </S.BarcodeSection>

          {/* Actions */}
          <S.Actions>
            <S.Button />
            <S.Button outlined />
          </S.Actions>

          {/* Confirmation */}
          <S.Confirmation />
        </S.Card>
      </S.Center>

      {/* Footer */}
      <S.FooterSkeleton />
    </S.Page>
  );
};
